var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("123123")]),_c('photo-selector',{attrs:{"type":"banner"},model:{value:(_vm.photo),callback:function ($$v) {_vm.photo=$$v},expression:"photo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }